import { useCallback, useState } from "react";
import { debounce } from "lodash";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchTitleNameSuggestions, } from "../api/titleService";
var MIN_SUGGEST_CHARS = 3;
export var useTitleNameSuggestions = function (params) {
    var _a = useState(""), suggestQuery = _a[0], setSuggestQuery = _a[1];
    var kyInstance = useOkapiKy();
    var updateSuggestQuery = useCallback(debounce(function (inputValue) {
        setSuggestQuery(inputValue);
    }, 300), []);
    var _b = useQuery(["titleNameSuggestions", suggestQuery, params], function () { return fetchTitleNameSuggestions(kyInstance, suggestQuery.trim(), params); }, {
        enabled: suggestQuery.trim().length >= MIN_SUGGEST_CHARS,
        staleTime: 30000,
        retry: false,
    }).data, suggestions = _b === void 0 ? [] : _b;
    return { suggestions: suggestions, updateSuggestQuery: updateSuggestQuery };
};
